import { BaseApiTemplateService, Core2Config } from "../../shared";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfProjectNotificationSubscriptionLoginLinkContainerModel } from "../../../../../../models/aggregates/wf/project/wf-project-notification-subscription-login-link-container.model";

@Injectable({ providedIn: 'root' })
export class WfProjectNotificationSubscriptionLoginLinkService extends BaseApiTemplateService<WfProjectNotificationSubscriptionLoginLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-notification-subscription-login-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-notification-subscription-login-links';
    this.httpClient = http;
  }
}
